import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { BaseModel } from '@shared/base/Base.Model';

export class SettingModel extends BaseModel implements IRestModel {

    public iD: string = null;
    public readonly isIRestModel = true;
    public value: string = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'EM-SettingModel');
    }

    public toRestApiModel() {
        throw new Error('Method not implemented.');
    }
}
